import type { TilsynsobjektV2 } from '../types/types'

export const findTilsynsobjektProdusentnummer = (
  tilsynsobjekt: TilsynsobjektV2
): string | undefined => {
  return tilsynsobjekt.identiteter.find((identitetstype) => {
    if (identitetstype.identitetstype.id === 'IDENTITETSTYPE$PRODUSENTNUMMER') {
      const validFrom =
        identitetstype.gyldigFra == null
          ? undefined
          : new Date(identitetstype.gyldigFra)
      const validTo =
        identitetstype.gyldigTil == null
          ? undefined
          : new Date(identitetstype.gyldigTil)
      const currentDate = new Date()
      return (
        validFrom != null &&
        validFrom <= currentDate &&
        ((validTo != null && validTo >= currentDate) || validTo == null)
      )
    } else {
      return false
    }
  })?.verdi
}
